import { graphql } from '../graphql/generated';

export const DOCTOR_HAS_AIS_QUERY = graphql(`
  query DoctorHasAis($id: ID!) {
    doctor(id: $id) {
      id
      hasAis
    }
  }
`);
